import config, {Brand} from '../config';
import { OrderLine } from '../transport/apiServiceResponse';

type BrandRewardsCopy = {
  loyaltyProgramName: string;
  menuTitle: string;
  exclusiveOffersTitle: string;
  promotionsTitle: string;
  memberPublicPricingTitle: string;
  memberPrivatePricingTitle: string;
};

const defaultRewardsCopy: BrandRewardsCopy = {
  loyaltyProgramName: 'More Rewards',
  menuTitle: 'Rewards',
  exclusiveOffersTitle: 'Exclusive Offers',
  promotionsTitle: 'Promotions',
  memberPublicPricingTitle: 'Member-Only Prices',
  memberPrivatePricingTitle: 'Just For You',
};

const rewardsCopy: Record<Brand, Partial<BrandRewardsCopy>> = {
  [Brand.BOTTLEMART]: {
  },
  [Brand.SIPNSAVE]: {
  },
  [Brand.THIRSTY_CAMEL]: {
    loyaltyProgramName: 'Camel Club',
    menuTitle: 'Camel Club',
    exclusiveOffersTitle: 'Unique Rewards',
    // promotionsTitle: 'Camel Competitions',
    memberPublicPricingTitle: 'Club Discounts',
    memberPrivatePricingTitle: 'Tailored Offers',
  },
  [Brand.HARRY_BROWN]: {
    loyaltyProgramName: "Harry's Perks",
    menuTitle: 'Rewards',
  },
  [Brand.DEVELOPMENT]: {
  },
};

/**
 * @deprecated use {@link brandRewardsCopy} instead
 */
export const rewardsMarketingName =
  rewardsCopy[config.BASE_TENANT].loyaltyProgramName ?? 'More Rewards';

// TODO Ideally we move this into the assets folder under some localization solution
export const brandRewardsCopy = {
  ...defaultRewardsCopy,
  ...rewardsCopy[config.BASE_TENANT],
};

/**
 * Utility function to get display rules for an order line (ie. products)
 * This can determine whether a sticker a shown or product displayed in a carousel
 * 
 * TODO: Makes sense to handle display logic in middleware, 
 * 1. We don't send unused data to the client in the first place.
 * 2. Cleaner to drive display rules from MW without needing to redeploy frontend.
 * 
 * This needs more consideration at it'll mean
 * 1. MW will no longer be a transparent MFL API proxy (we will need our own models)
 * 2. It will be a decent chunk of refactoring work and regression testing
 **/ 
export const getProductDisplayRules = (orderLine: OrderLine) => {
  const {extra_prices = []} = orderLine;

  const nonMemberPrice = extra_prices.find(
    (price) => price.price_level_external_reference === 'non_member_price'
  );
  
  const publicLoyaltyPrice = extra_prices.find(
    (price) => price.price_level_external_reference === 'lmg_loyalty' && price.external_sell_type === 'public'
  );

  const privateLoyaltyPrice = extra_prices.find(
    (price) => price.price_level_external_reference === 'lmg_loyalty' && price.external_sell_type === 'private'
  );
  
  const isPublicLoyaltyPricingBetter = publicLoyaltyPrice && nonMemberPrice && publicLoyaltyPrice.sell_price < nonMemberPrice.sell_price;
  const isPrivateLoyaltyPricingBetter = privateLoyaltyPrice && nonMemberPrice && privateLoyaltyPrice.sell_price < nonMemberPrice.sell_price;
  
  return {
    presentAsPublicMemberProduct: isPublicLoyaltyPricingBetter,
    presentAsPrivateMemberProduct: isPrivateLoyaltyPricingBetter,
  }
}
export type ProductDisplayRules = ReturnType<typeof getProductDisplayRules>;